// Navbar related

const mainNav= document.querySelector(".main-nav");
const overlay = mainNav.querySelector(".overlay");
const toggler = mainNav.querySelector(".navbar-toggler");
const xButton = mainNav.querySelector(".btn-close");
const menuLinks = mainNav.querySelectorAll('.nav-link:not(.dropdown-toggle)');

const openSideNav = () => mainNav.classList.add("active");
const closeSideNav = () => mainNav.classList.remove("active");

toggler.addEventListener("click", openSideNav);
overlay.addEventListener("click", closeSideNav);
menuLinks.forEach( link => {
    link.addEventListener("click", closeSideNav);
});
xButton.addEventListener("click", closeSideNav);


/**
* ------------------------------------------------------------------------
* Scroll to Top
* ------------------------------------------------------------------------
* 
*/


    jQuery(document).ready(function($){
      var offset = 100;
      var speed = 250;
      var duration = 500;
          $(window).scroll(function(){
              if ($(this).scrollTop() < offset) {
                        $('.topbutton') .fadeOut(duration);
              } else {
                        $('.topbutton') .fadeIn(duration);
              }
          });
       $('.topbutton').on('click', function(){
              $('html, body').animate({scrollTop:0}, speed);
              return false;
              });
  });

/**
* ------------------------------------------------------------------------
* Owl Carousel Initiate
* ------------------------------------------------------------------------
* 
*/
    jQuery(function($) { $('.owl-carousel-ambasadors').owlCarousel({
      items: 5,
      loop: true,
      nav: true,
      autoplayTimeout: 6000,
      autoplayHoverPause:true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,
            margin: 30,
            autoplay: true,
        },
        480: {
            nav: true,
            dots: false,
            margin: 60,
            autoplay: false,
        },
    }, 
    })});

    jQuery(function($) { $('.owl-carousel-prelegates').owlCarousel({
      items: 5,
      loop: true,
      nav: true,
      autoplay: true,
      autoplayTimeout: 1500,
      autoplayHoverPause:true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,
            margin: 30,
        },
        480: {
            nav: true,
            dots: false,
            margin: 0,
        },
    }, 
  })});

    jQuery(function($) { $('.owl-carousel-teachers').owlCarousel({
      items: 5,
      loop: true,
      nav: true,
      autoplay: true,
      autoplayTimeout: 1500,
      autoplayHoverPause:true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,
            margin: 30,
        },
        480: {
            nav: true,
            dots: false,
            margin: 0,
        },
    }, 
  })});

  jQuery(function($) { $('.owl-carousel-artists').owlCarousel({
    items: 5,
    loop: true,
    nav: true,
    autoplay: true,
    autoplayTimeout: 1500,
    autoplayHoverPause:true,
    navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
    responsive :{ 
      0 : {
          nav: false,
          items: 2,
          dots: true,
          margin: 30,
      },
      480: {
          nav: true,
          dots: false,
          margin: 0,
      },
  }, 
})});

  

    jQuery(function($) { $('.owl-carousel-sponsors').owlCarousel({
        items: 6,
        loop: true,
        nav: true,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause:true,
        navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
        responsive :{ 
          0 : {
              nav: false,
              items: 2,
              dots: true,
              margin: 30,      
          },
          480: {
              nav: true,
              dots: false,
              margin: 45,
          },
      }, 
    })});

    jQuery(function($) { $('.owl-carousel-honored').owlCarousel({
      items: 6,
      loop: false,
      nav: true,
      center:true,
      autoplay: false,
      autoplayTimeout: 6000,
      autoplayHoverPause:true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,
            margin: 30,      
        },
        480: {
            nav: true,
            dots: false,
            margin: 45,
        },
    }, 
    })});

    jQuery(function($) { $('.owl-carousel-partners').owlCarousel({
      items: 6,
      loop: true,
      nav: true,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause:true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,
            margin: 30,      
        },
        480: {
            nav: true,
            dots: false,
            margin: 45,
        },
    }, 
    })});

    jQuery(function($) { $('.owl-carousel-media').owlCarousel({
      items: 6,
      loop: true,
      nav: true,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause:true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,
            margin: 30,      
        },
        480: {
            nav: true,
            dots: false,
            margin: 45,
        },
    }, 
  })});



/**
* ------------------------------------------------------------------------
* Slider thumbnail
* ------------------------------------------------------------------------
* 
*/
jQuery(function($){
  $(document).ready(function() {
    var bigimage = $("#big");
    var thumbs = $("#thumbs");
    //var totalslides = 10;
    var syncedSecondary = true;
  
    bigimage
      .owlCarousel({
      items: 1,
      slideSpeed: 2000,
      nav: false,
      autoplay: true,
      dots: false,
      loop: true,
      responsiveRefreshRate: 200,
    })
      .on("changed.owl.carousel", syncPosition);
  
    thumbs
      .on("initialized.owl.carousel", function() {
      thumbs
        .find(".owl-item")
        .eq(0)
        .addClass("current");
    })
      .owlCarousel({
      items: 4,
      margin:30,
      dots: false,
      nav: true,
      navText:["<div class='nav-btn prev-slide'><i class='bi bi-caret-left-fill'></i></div>","<div class='nav-btn next-slide'><i class='bi bi-caret-right-fill'></div>"],
      smartSpeed: 200,
      slideSpeed: 500,
      slideBy: 4,
      responsiveRefreshRate: 100,
      responsive :{ 
        0 : {
            nav: false,
            items: 2,
            dots: true,     
        },
        480: {
            nav: true,
            dots: false,
        },
      }
    })
      .on("changed.owl.carousel", syncPosition2);
  
    function syncPosition(el) {
      //if loop is set to false, then you have to uncomment the next line
      //var current = el.item.index;
  
      //to disable loop, comment this block
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);
  
      if (current < 0) {
        current = count;
      }
      if (current > count) {
        current = 0;
      }
      //to this
      thumbs
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
      var onscreen = thumbs.find(".owl-item.active").length - 1;
      var start = thumbs
      .find(".owl-item.active")
      .first()
      .index();
      var end = thumbs
      .find(".owl-item.active")
      .last()
      .index();
  
      if (current > end) {
        thumbs.data("owl.carousel").to(current, 100, true);
      }
      if (current < start) {
        thumbs.data("owl.carousel").to(current - onscreen, 100, true);
      }
    }
  
    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        bigimage.data("owl.carousel").to(number, 100, true);
      }
    }
  
    thumbs.on("click", ".owl-item", function(e) {
      e.preventDefault();
      var number = $(this).index();
      bigimage.data("owl.carousel").to(number, 300, true);
    });
  });  
});

/**
* ------------------------------------------------------------------------
* Scroll to anchor
* ------------------------------------------------------------------------
* 
*/
jQuery(function($){
  $(document).ready(function(){
    const offset = 88; // Adjust to match your header height

    // Smooth scrolling for same-page anchor links
    $('.menu-item a[href*="#"]').on('click', function(event) {
      const hash = this.hash;
      const pathname = this.pathname.replace(/^\//, '');
      const locationPath = location.pathname.replace(/^\//, '');

      // Check if the link is on the same page
      const isSamePage = pathname === locationPath && this.hostname === location.hostname;

      if (isSamePage && hash && $(hash).length) {
        event.preventDefault(); // Only prevent default if we're handling it

        $('html, body').animate({
          scrollTop: $(hash).offset().top - offset
        }, 300);
      }
    });

    // Handle anchor offset on page load
    const initialHash = window.location.hash;
    if (initialHash && $(initialHash).length) {
      setTimeout(function() {
        $('html, body').scrollTop($(initialHash).offset().top - offset);
      }, 1);
    }
  });
});


// /**
// * ------------------------------------------------------------------------
// * Popup modal
// * ------------------------------------------------------------------------
// * 
// */

// // Get the modal
// var poppers = document.getElementById("poppers");


// // Get the <span> element that closes the modal
// var span = document.getElementById("poppers-close");


// // When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   poppers.style.display = "none";
// }

// // When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == poppers) {
//     poppers.style.display = "none";
//   }
// } 

// /**
// * ------------------------------------------------------------------------
// * Accordion
// * ------------------------------------------------------------------------
// * 
// */
document.addEventListener("DOMContentLoaded", function() {
  const accordionButtons = document.querySelectorAll('.accordion-button');

  accordionButtons.forEach(button => {
      button.addEventListener('click', function() {
          const accordionItem = this.parentElement.parentElement;
          const accordionBody = accordionItem.querySelector('.accordion-collapse');

          // Toggle the 'active' class on the button
          this.classList.toggle('active');

          // Show or hide the content
          if (accordionBody.style.maxHeight) {
              accordionBody.style.maxHeight = null;
          } else {
              accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
          }
      });
  });
});